import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@cmsgov/design-system';
import { useNavigate } from 'react-router-dom';

import { navigateByRole, type UserRole } from '@utils/tools/landingPage';

interface PreferencesPageControlsProps {
    actionName: string;
    formName: string;
    handleClick: () => void;
    isDashboardLocation?: boolean;
    fromCAP?: boolean;
    navigateToCAP?: () => void;
    landingPage?: string | null;
    role?: UserRole | null;
}

const PreferencesPageControls = (props: PreferencesPageControlsProps) => {
    const {
        actionName,
        formName,
        handleClick,
        isDashboardLocation,
        fromCAP,
        navigateToCAP,
        landingPage,
        role,
    } = props;

    const navigate = useNavigate();

    const handleCancel = () => {
        if (fromCAP) {
            navigateToCAP?.();
            return;
        }

        navigateByRole(role, landingPage, navigate);
    };

    return (
        <div className="tablet:grid-offset-5 txt-left">
            <Button
                className="usa-button gi-button gi-button__primary"
                data-form_name={formName}
                data-action_name={actionName}
                onClick={handleClick}
            >
                <FormattedMessage id="button.go_to_dashboard" />
            </Button>

            {(isDashboardLocation || fromCAP) && (
                <Button className="usa-button gi-button gi-button__primary" onClick={handleCancel}>
                    <FormattedMessage id="button.cancel" />
                </Button>
            )}
        </div>
    );
};

export default PreferencesPageControls;
